import React, {useState, useEffect, useContext} from 'react';
import axios from '../Common/axios';
import dayjs from 'dayjs';
import {Button, Select, DatePicker, Input, Tag, InputNumber, Modal} from "antd";
import { ExclamationCircleFilled } from '@ant-design/icons';
import {CodeSelect} from '../Common/CodeSelect';
import {postEditVaReportData, postDeleteVaReportData} from '../Common/api';
import TextArea from 'antd/es/input/TextArea';
import AppContext from '../../components/AppContext';
import { useNavigate } from 'react-router-dom';
import {getPopupSizeOption} from '../Common/util';

const {Option} = Select;

/** -------------------------------------------------------------------------- **/
function InfoReport({reportId, reportInfo, onChangeAfter, onChangeClose }) {

    // 변수 선언
    
    const myContext = useContext(AppContext);
    const navigate = useNavigate();
    const [companyCode, setCompanyCode] = useState('');
    const [assetType, setAssetType] = useState('');
    const [reportName, setReportName] = useState('');
    const [reportDesc, setReportDesc] = useState('');
    const [createdYmd, setCreatedYmd] = useState('');
    const [updatedYmd, setUpdatedYmd] = useState('');
    const [confirmYn, setConfirmYn] = useState('');
    const [reportOrg, setReportOrg] = useState('');
    const [assetSpec, setAssetSpec] = useState('');
    const [RiskGrdHigh, setRiskGrdHigh] = useState(12);  //12이상이면 High
    const [RiskGrdLow, setRiskGrdLow] = useState(5);    //5이하이면 Row

    const [isLoading, setIsLoading] = useState(false);
    const dateFormat = 'YYYY-MM-DD';
    const titleName="보고서 상세";

    useEffect(() => {
        if(reportInfo) {
            //console.log(reportInfo);
            setCompanyCode(reportInfo.com_cd);
            setAssetType(reportInfo.asset_type);
            setReportName(reportInfo.report_nm);
            setReportOrg(reportInfo.report_org);
            setReportDesc(reportInfo.report_desc);
            setCreatedYmd(reportInfo.created_ymd);
            setUpdatedYmd(reportInfo.updated_ymd);
            setConfirmYn(reportInfo.confirm);
            setReportOrg(reportInfo.report_org || '');
            setAssetSpec(reportInfo.asset_spec || '');
            setRiskGrdHigh(reportInfo.risk_grd_high);
            setRiskGrdLow(reportInfo.risk_grd_low);
        }
    }, [reportInfo]);

    // 확정여부 변경
    const onChangeConfirmYn = (value) => {
        setConfirmYn(value);
    };

    // 템플릿ID 클릭 시 새 창으로 템플릿 페이지 열기
    const onClickTemplateId = (e) => {
        e.preventDefault();
        if (reportOrg) {
            // 새 창으로 템플릿 정보 페이지 열기
            const popupOption = getPopupSizeOption(1500, 850);
            window.open(
                `#/template/info/${reportOrg}`, 
                'templateInfo',
                popupOption
            );
        }
    };

    // InputText 입력값 변경
    const onChangeInputHandler = (event) => {
        if (event.target.id == "reportName") {
            setReportName(event.target.value);
        } else if (event.target.id == "reportDesc") {
            setReportDesc(event.target.value);
        } 
    };

    // Date 입력값 변경
    const onChangeCreatedYmd = (values, formatString) => {
        //console.log(formatString);
        if(formatString != null) {
            setCreatedYmd(formatString.replace(/[-]/g,''));
        } else {
            setCreatedYmd('');
        }
    };

    const onChangeUpdatedYmd = (values, formatString) => {
        //console.log(formatString);
        if(formatString != null) {
            setUpdatedYmd(formatString.replace(/[-]/g,''));
        } else {
            setUpdatedYmd('');
        }
    };
    
    // 수정
    const onClickSaveHandler = () => {
        // 필수조건 체크
        if (companyCode == '' || assetType == '' || reportName == '') {
            Modal.info({title: "Required fields are missing."});
            return;
        }

        // 변경여부 체크
        if (reportInfo.report_nm == reportName && reportInfo.report_desc ==reportDesc
            && reportInfo.created_ymd ==createdYmd && reportInfo.updated_ymd ==updatedYmd 
            && reportInfo.confirm ==confirmYn
            && reportInfo.risk_grd_high ==RiskGrdHigh && reportInfo.risk_grd_low ==RiskGrdLow) {
            Modal.info({title:titleName, content:"변경된 정보가 없습니다.", okText:"Close"});
            return;
        }

        setIsLoading(true);
            axios.post(postEditVaReportData(), {
                    reportId : reportId,
                    companyCode : companyCode,
                    assetType : assetType,
                    reportName : reportName,
                    reportDesc : reportDesc,
                    createdYmd : createdYmd,
                    updatedYmd : updatedYmd,
                    confirm : confirmYn,
                    risk_grd_high : RiskGrdHigh,
                    risk_grd_low : RiskGrdLow,
            }, {logCompany : companyCode, logParam : reportId})
            .then((response) => {
                //console.log(response);
                setIsLoading(false);
                //Modal.info({title: "OK.", okText:"Close"});
                if(response.data.status === 'success') {
                    Modal.info({title:titleName, content:"정상적으로 수정되었습니다.", okText:"Close", onOk() {
                        onChangeAfter();
                    }});
                } 
            })
            .catch((error) => {
                setIsLoading(false);
                Modal.error({title:titleName, content:error.response.data.error, okText:"Close"});
            });
    };

    // 삭제 전 확인
    const onClickDeleteHandler = () => {

        Modal.confirm({
            title: '정말로 삭제하시겠습니까?',
            content: '보고서를 삭제하면 아래 기준과 결과 레포트가 모두 삭제됩니다.',
            icon: <ExclamationCircleFilled />,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                fnDeleteVaReportData();
            },
        });
    }

    // 삭제
    const fnDeleteVaReportData = () => {

        setIsLoading(true);
        axios.post(postDeleteVaReportData(), {
            reportId : reportId,
          }, {logCompany : companyCode, logParam : reportId})
          .then((response) => {
            setIsLoading(false);
            //Modal.info({title: "OK.", okText:"Close"});
            if(response.data == '보고서 삭제가 완료되었습니다.') {
                Modal.info({title:titleName, content:response.data, okText:"Close", onOk() {
                    //정상적으로 삭제된 경우, 부모창을 재조회하고 팝업창을 닫는다.
                    //window.opener.parentCallback();
                    //window.close();
                    onChangeClose();
                }});
            } else {
                Modal.info({title:titleName, content:response.data, okText:"Close"});  
            }
        })
        .catch((error) => {
            setIsLoading(false);
            Modal.error({title:titleName, content:error.message, okText:"Close"});
        });

    }

    return (
        <div className='tab_content'>
            <div className="section">
                <table className='search_report'>
                    <colgroup>
                        <col style={{width:'20%'}} />
                        <col />
                    </colgroup>
                    <tbody>
                    <tr>
                        <th><span className='req'>*</span>회사</th>
                        <td>
                            <CodeSelect codeType="com_cd" 
                                        value={companyCode}
                                        disabled={true}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th><span className='req'>*</span>자산구분</th>
                        <td>
                            <CodeSelect codeType="asset_type" 
                                        value={assetType}
                                        disabled={true}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>자산스펙</th>
                        <td>
                            {assetSpec && assetSpec.split(',').map((spec, index) => (
                                <span
                                    key={index}
                                    style={{
                                        backgroundColor: '#b3d9ff',
                                        color: '#333',
                                        padding: '2px 8px',
                                        borderRadius: '4px',
                                        marginRight: '4px',
                                        marginBottom: '2px',
                                        fontSize: '12px',
                                        display: 'inline-block',
                                        border: '1px solid #87ceeb'
                                    }}
                                >
                                    {spec.trim().replace(/[\[\]'",]/g, '')}
                                </span>
                            ))}
                        </td>
                    </tr>
                    <tr>
                        <th><span className='req'>*</span>취약점분석 제목</th>
                        <td>
                            <Input size="small" style={{width: "80%"}}
                                    allowClear
                                    value={reportName}
                                    onChange={onChangeInputHandler}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th><span className='req'>*</span>템플릿명</th>
                        {/* <td><div onClick={onClickTemplateId} style={{cursor: 'pointer'}}>{reportOrg}</div></td> */}
                        <td><a href="#" onClick={onClickTemplateId} style={{cursor: 'pointer'}}>{reportOrg}</a></td>
                    </tr>
                    <tr>
                        <th><span className='req'>*</span>위험등급기준</th>
                        <td>
                        <Tag color={'volcano'}> High </Tag> 
                        <InputNumber min={1} max={9} value={myContext.riskGrdHigh} size={'small'} style={{ width: '50px' }} disabled />이상
                        {/* <InputNumber min={10} m상x={20} value={RiskGrdHigh} size={'small'} style={{width:'50px'}} onChange={(value) => {setRiskGrdHigh(value)}}/>이상 */}
                        &nbsp; ~ &nbsp;&nbsp;
                        <Tag color={'green'}> Low </Tag> 
                        <InputNumber min={1} max={9} value={myContext.riskGrdRow} size={'small'} style={{ width: '50px' }} disabled />미만
                        {/* <InputNumber min={1} max={9} value={RiskGrdLow} size={'small'} style={{width:'50px'}} onChange={(value) => {setRiskGrdLow(value)}} />이하 */}
                        </td>
                    </tr> 
                    <tr>
                        <th>최초분석일자</th>
                        <td>
                            <DatePicker id="createdYmd" size="small" allowClear 
                                format={dateFormat}
                                value={createdYmd ? dayjs(createdYmd, 'YYYYMMDD') : null}  
                                onChange={onChangeCreatedYmd} />
                        </td>
                    </tr>
                    <tr>
                        <th>이행분석일자</th>
                        <td>
                            <DatePicker id="updatedYmd" size="small" allowClear 
                                format={dateFormat}
                                value={updatedYmd ? dayjs(updatedYmd, 'YYYYMMDD') : null}  
                                onChange={onChangeUpdatedYmd} />
                        </td>
                    </tr>
                    <tr>
                        <th><span className='req'>*</span>취약점분석 확정여부</th>
                        <td>
                            <Select
                                    size="small"
                                    style={{width: "80%"}}
                                    value={confirmYn}
                                    onChange={onChangeConfirmYn}
                            >
                                <Option key={0} value={'N'}> 미확정 </Option>
                                <Option key={1} value={'Y'}> 확정 </Option>
                            </Select>
                        </td>
                    </tr>
                    <tr>
                        <th>취약점분석 요약</th>
                        <td>
                            <TextArea id="reportDesc" size="small" style={{width: "80%"}}
                                    allowClear
                                    value={reportDesc}
                                    showCount
                                    maxLength={1000}
                                    onChange={onChangeInputHandler}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div className="popup_button_close">
                    <Button
                        type="primary"
                        onClick={onClickSaveHandler}
                        loading={isLoading}
                        style={{marginRight: '10px'}}
                    >
                        {'보고서 수정'}
                    </Button>
                    <Button
                    type="default"
                    onClick={onClickDeleteHandler}
                    style={{marginLeft: '10px'}}
                    loading={isLoading}
                >
                    {'보고서 삭제'}
                </Button>
            </div>
        </div>
    );
}
export default InfoReport;